import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Evaluator } from 'formiojs/utils/utils';
import { KeycloakService } from 'keycloak-angular';
import {
  Observable,
  catchError,
  finalize,
  from,
  map,
  of,
  switchMap,
} from 'rxjs';
import {
  ResourceNameService,
  STEPPERTABSTATUS,
  UserService,
} from 'dp-formio';
import { CustomOptionsModel, DialogData, commentColumnModel } from '../models';

@Component({
	selector: 'app-comments-history-dialog',
	templateUrl: './comments-history-dialog.component.html',
	styleUrls: ['./comments-history-dialog.component.scss'],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommentsHistoryDialogComponent implements OnInit {
	showLoader: boolean;
	hasError: boolean;

	options: CustomOptionsModel;
	data: Record<string, any>;
	comments$: Observable<Record<string, any>[]> = of([]);

	translationsKey = 'forms.common.';
	tabStatusEnum = STEPPERTABSTATUS;

	_columns: commentColumnModel[] = [
		{
			key: 'notes',
			label: 'notes',
			translated: false,
		},
	];
	columns: commentColumnModel[] = this._columns;
	constructor(
		public dialogRef: MatDialogRef<CommentsHistoryDialogComponent, any>,
		@Inject(MAT_DIALOG_DATA) public dialogData: DialogData,
		private resourceNameService: ResourceNameService,
		private userService: UserService,
		private keycloak: KeycloakService
	) {}

	ngOnInit(): void {
		this.data = this.dialogData?.data;
		this.options = this.dialogData?.options;
		this.translationsKey =
			this.dialogData?.options?.translationKey || this.translationsKey;

		this._prepareColumns();
		this._fetchData();
	}

	cancel() {
		this.dialogRef.close();
	}

	private _prepareColumns() {
		const _columns = this.dialogData?.options?.columns ?? [];
		this.columns =
			Array.isArray(_columns) && _columns.length ? _columns : this._columns;
	}

	private _fetchData() {
		this.showLoader = true;
		this.comments$ = from(this.keycloak.getToken()).pipe(
			switchMap((token) => this.userService.getUserData(token)),
			switchMap((userData) => {
				const query = Evaluator.interpolate(this.options.query, {
					data: { ...this.data, ...userData },
				});
				return this.resourceNameService.loadCustomByFilterdKey(
					this.options.resourceKey,
					query
				);
			}),
			catchError((error) => {
				console.log(error);
				this.hasError = true;
				return of([]);
			}),
			finalize(() => {
				this.showLoader = false;
			}),
			map((data) =>
				Array.isArray(data) && !!data.length
					? data.map((item: any) => item.data)
					: []
			)
		);
	}
}
